<template>
  <v-app id="QB">
    <v-app-bar
      app
      clipped-right
      clipped-left
      flat
      v-if="videocall"
      color="transparent"
      dark
    ></v-app-bar>
    <v-app-bar app clipped-right clipped-left flat v-else color="primary" dark>
      <v-app-bar-nav-icon
        v-if="!videocall"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <div
        style=" 
           
    ;background-image:url('https://uvi24.es/img/logo.svg');height:50px;    width: 200px; margin:auto;"
        class="mx-16"
      ></div>
      <div class="text-h5 text-center" style="left: 400px;position: fixed;">
        {{ this.name }}
        <v-btn
          icon
          @click="createCall()"
          v-if="selectedDialog && canCall(selectedDialog)"
          class="mx-16"
        >
          <v-icon color="white" size="40">mdi-video-outline</v-icon>
        </v-btn>
      </div>

      <!-- <v-btn icon @click="createCall()">
        <v-icon>mdi-phone-outline</v-icon>
      </v-btn>
      <v-icon>mdi-phone-remove</v-icon>
      <v-icon>mdi-phone-outline</v-icon>-->
      <!-- <v-btn text v-for="contact in contactList" :key="contact._id" color="grey">{{contact}} ---</v-btn> -->

      <v-spacer />

      <v-btn @click="signOut()" color="white" outlined>Cerrar sesión</v-btn>
      <!-- <v-menu bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-avatar>
              <img src="https://randomuser.me/api/portraits/women/81.jpg" />
            </v-avatar>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="signOut()">
            <v-list-item-title>Cerrar sesión</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>-->
    </v-app-bar>

    <v-navigation-drawer
      v-if="!videocall"
      v-model="drawer"
      app
      clipped
      color
      width="400px"
    >
      <!-- <v-list dense nav> -->
      <v-list three-line dense nav>
        <v-card
          :loading="canCall(dialog)"
          class="mx-auto my-0"
          width="400"
          flat
          :key="dialog._id"
          v-for="dialog in proximascitas"
          @click="selectDialog(dialog)"
        >
          <template slot="progress">
            <v-progress-linear
              :color="color_citas_status(dialog)"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-row class="py-0">
            <v-col class="py-0">
              <v-card-title>
                <v-icon :color="color_citas_status(dialog)"
                  >mdi-checkbox-blank-circle</v-icon
                >
                {{ dialog.name }}
              </v-card-title>
            </v-col>
            <v-col cols="5" v-if="canCall(dialog)">
              <v-card-title class="green--text">En cita</v-card-title>

              <!-- <v-progress-circular
                size="70"
                width="15"
                value="30"
                :color="color_citas_status(dialog)"
              >30</v-progress-circular>-->
            </v-col>
            <v-col cols="5" v-if="color_citas_status(dialog) == 'yellow'">
              <v-card-title class="orange--text">Uso de chat</v-card-title>

              <!-- <v-progress-circular
                size="70"
                width="15"
                value="30"
                :color="color_citas_status(dialog)"
              >30</v-progress-circular>-->
            </v-col>
          </v-row>
          <v-card-text class="py-0 mx-2">
            <div
              class="blue-grey--text"
              :key="cita.id"
              v-for="cita in dialog.citas"
            >
              <div v-if="cita_next(cita.cita)">
                <div class="my-4 subtitle-1">
                  Proxima cita
                  <timeago :datetime="cita.cita" :auto-update="60"></timeago>:
                  <span class="text--primary">{{ cita.description }}</span>
                </div>
              </div>
              <div v-else>
                <div class="my-4 subtitle-2">
                  Cita
                  <timeago :datetime="cita.cita" :auto-update="60"></timeago>:
                  <span class="text--primary">{{ cita.description }}</span>
                </div>
              </div>
            </div>
            <div class="my-4 subtitle-2">
              ULTIMO MENSAJE:
              <span class="text--primary">{{ dialog.last_message }}</span>
              <!-- <timeago
                class="grey--text"
                :datetime="new Date(1000*dialog.last_message_date_sent)"
                :auto-update="60"
              ></timeago>-->
            </div>
          </v-card-text>
          <div v-if="false">
            <v-card-text class="bold text--accent-2 text-h6"
              >Otras Citas</v-card-text
            >

            <v-card-text class="ml-12">{{ dialog.cita }}</v-card-text>
          </div>
          <v-divider class="mx-4"></v-divider>
        </v-card>

        <!-- <v-list-item-icon v-if="dialog.unread_messages_count">
        {{dialog.unread_messages_count}}-->
        <!-- <v-icon :color="dialog.unread_messages_count ? 'primary' : 'grey'">mdi-chat</v-icon> -->
        <!-- </v-list-item-icon> -->
        <v-card
          class="mx-auto my-0"
          width="400"
          flat
          :key="dialog._id"
          v-for="dialog in dialogs"
          @click="selectDialog(dialog)"
        >
          <v-card-title>{{ dialog.name }}</v-card-title>

          <v-card-text>
            <v-row align="center" class="mx-0">
              <div class="grey--text">
                Visto por última vez
                <timeago
                  :datetime="dialog.updated_at"
                  :auto-update="60"
                ></timeago>
              </div>
            </v-row>

            <div class="my-4 subtitle-1">{{ dialog.last_message }}</div>
          </v-card-text>

          <v-divider class="mx-4"></v-divider>
        </v-card>
      </v-list>
    </v-navigation-drawer>

    <v-container fluid fill-height app style="max-height: calc(100% - 64px);  ">
      <v-hover
        v-slot:default="{ hover }"
        close-delay="1500"
        open-delay="100"
        v-if="videocall"
      >
        <div class="background">
          <v-progress-circular
            size="130"
            width="15"
            :value="timeValue(selectedDialog)"
            :indeterminate="timeValue(selectedDialog) == 0"
            :color="color_citas_status(selectedDialog)"
          >
            <div class="text-h5">{{ clock }}</div>
          </v-progress-circular>

          <video
            id="remoteVideoBlurred"
            :muted="!showLocalVideo"
            :class="{ videorotated: videorotated, videoremote: !videorotated }"
          ></video>
          <video
            id="remoteVideo"
            :muted="!showLocalVideo"
            :class="{ videorotated: videorotated, videoremote: !videorotated }"
          ></video>
          <div
            v-if="hover || true"
            style="bottom: 60px;
    position: absolute;
    text-align: center;
    width: inherit;"
          >
            <v-btn
              @click="muteAudio()"
              fab
              dark
              color="primary"
              style=" 
    z-index: 4; margin:10px;"
            >
              <v-icon v-if="audioMuted">mdi-microphone-off</v-icon>
              <v-icon v-else>mdi-microphone</v-icon>
            </v-btn>
            <v-btn
              @click="muteVideo()"
              fab
              dark
              color="primary"
              style=" 
    z-index: 4; margin:10px;"
            >
              <v-icon v-if="videoMuted">mdi-video-off-outline</v-icon>
              <v-icon v-else>mdi-video-outline</v-icon>
            </v-btn>
            <v-btn
              @click="stopCall()"
              fab
              dark
              color="red"
              large
              style=" 
    z-index: 4; margin:10px;"
            >
              <v-icon>mdi-phone-hangup-outline</v-icon>
            </v-btn>

            <v-btn
              @click="showChat()"
              fab
              dark
              color="primary"
              style=" 
    z-index: 4; margin:10px;"
            >
              <v-icon v-if="chatShowed">mdi-message-bulleted</v-icon>

              <v-icon v-else>mdi-message-bulleted-off</v-icon>
            </v-btn>
            <v-btn
              @click="videorotated = !videorotated"
              fab
              dark
              color="primary"
              style=" 
    z-index: 4; margin:10px;"
            >
              <v-icon v-if="videorotated">mdi-phone-rotate-landscape</v-icon>

              <v-icon v-else>mdi-phone-rotate-portrait</v-icon>
            </v-btn>
          </div>
        </div>
      </v-hover>
      <!-- <v-progress-circular
        v-if="videocall "
        size="100"
        :value="100"
        :color="color_citas_status(selectedDialog)"
      >{{timeCall}}</v-progress-circular>-->
      <div
        v-if="videocall"
        style="    position: fixed;
    top: 10px;
    right: 32px;
    z-index: 1;
max-width: 350px;    padding: 10px
        transform: scaleX(-1);     
"
      >
        <!--  -->
        <video id="localVideo" muted style="max-height: 100;max-width: 100%;" />
        <!-- border: white 3px solid; -->

        <!-- <v-expand-transition>
              <div
                v-if="hoverMiniVideo"
                class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal display-3 white--text"
                style="height: 100%;"
              >
                <v-icon>mdi-arrow-expand</v-icon>
              </div>
        </v-expand-transition>-->
      </div>
      <chat
        :QB="$QB"
        @onMessageWasSent="onMessageWasSent"
        :messages="messages"
        :userId="userId"
        v-if="chatShowed && selectedDialog"
        @loadMoreChats="loadMoreChats()"
      />
    </v-container>

    <v-footer app inset v-if="chatShowed && selectedDialog">
      <div v-if="file">
        <v-row>
          <v-col>
            <v-img
              v-if="filetype.includes('image')"
              :src="file"
              style="max-width:200px;max-height:100px"
            />

            <video
              controls
              v-if="filetype.includes('video')"
              :src="file"
              width="200px"
              height="100px"
              @click="this.play()"
            />
            <audio
              controls
              v-if="filetype.includes('audio')"
              :src="file"
              width="300px"
              @click="this.play()"
            />
          </v-col>
          <v-col>
            <v-btn icon @click="file = null">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-text-field
        v-model="text"
        label="Escribe un mensaje"
        type="text"
        no-details
        outlined
        @keyup.enter="onMessageWasSent"
        hide-details
        aria-autocomplete="off"
        autocomplete="off"
      >
        <template slot="append">
          <input
            type="file"
            ref="file"
            @change="previewFile"
            id="fileUpload"
            hidden
          />

          <v-icon @click="chooseFile">mdi-paperclip</v-icon>

          <v-icon v-if="!sending" @click="onMessageWasSent">mdi-send</v-icon>
        </template>
      </v-text-field>
      <v-progress-circular
        v-if="sending"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-footer>
  </v-app>
</template>

<script>
import { CREDENTIALS } from "./config";
import chat from "@/components/chat";
import AuthService from "@/service/auth_service";

// import { loadQuickBlox } from "./loadQuickBlox";

// var QB = require("quickblox");

export default {
  name: "QuickBlox",
  components: { chat },
  data() {
    return {
      text: "",
      file: null,
      clock: null,
      fileType: null,
      skipChats: 0,
      // firebase: firebaseapp,
      audio: new Audio(require("@/assets/ringtones-kill-bill-whistle.mp3")),
      videorotated: false,
      chatShowed: true,
      videoMuted: false,
      audioMuted: false,
      hoverVideo: false,
      opponentId: null,
      chat: null,
      session: null,
      showLocalVideo: false,
      videocall: false,
      drawer: null,
      calling: false,
      citas: [],
      proximascitas: [],
      dialogs: [],
      messages: [],
      contactList: [],
      userId: null,
      localStream: null,
      name: "",
      // login: this.$store.state.user,
      password: "kdfqKCYopn2ApPza6cwx",
      full_name: "Prueba",
      selectedDialog: null,
      currentUser: null,
      token: null,
      sending: false,
    };
  },
  computed: {
    timeCall() {
      let time = "";
      if (this.videocall) {
        for (let cita of this.selectedDialog.citas) {
          let minTo = (new Date(cita.cita) - new Date()) / 1000 / 60;
          let secsTo = (new Date(cita.cita) - new Date()) / 1000 - minTo * 60;
          if (minTo < 0 && minTo > -25) {
            time = minTo + ":" + secsTo;
            break;
          } else {
            time = "--:--";
          }
        }
      }
      return time;
    },
    // token: () => this.$store.state.token,
    // userId: () => (AuthService.currentUser ? AuthService.currentUser.uid : null)
  },
  mounted() {
    setInterval(this.updateTime, 1000);

    AuthService.onAuthStateChanged((user) => {
      this.currentUser = user;
      // this.getMyData();
      this.getCitas();
      this.initQB();
    });
  },
  methods: {
    previewFile() {
      console.log(this.$refs.file);
      //this.file = ;
      var reader = new FileReader();
      this.filetype = this.$refs.file.files[0].type;
      reader.onload = (e) => {
        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
        // Read image as base64 and set to imageData
        this.file = e.target.result;
      };
      // Start the reader job - read file as a data url (base64 format)
      reader.readAsDataURL(this.$refs.file.files[0]);
    },
    chooseFile() {
      let fileInputElement = this.$refs.file;
      fileInputElement.click();
    },
    getMyData() {
      this.axios.get("https://todopet.es/api/veterinarios").then((response) => {
        console.log(response.data);

        // this.citas = response.data;
      });
    },
    getCitas() {
      setTimeout(() => this.getCitas(), 300000);
      this.axios
        .get("https://todopet.es/api/citas?id=" + this.currentUser.uid)
        .then((response) => {
          console.log(response);
          this.citas = [];
          if (response.data) {
            response.data.forEach((cita) => {
              if (this.citas[cita.id_quickblox]) {
                this.citas[cita.id_quickblox].push(cita);
                this.citas[cita.id_quickblox].sort((a, b) =>
                  new Date(a.cita) < new Date(b.cita) ? 1 : -1
                );
              } else {
                this.citas[cita.id_quickblox] = [cita];
              }
            });

            // this.citas[x.id_quickblox]
            // this.citas = Object.assign(
            //   {},
            //   ...response.data.map(x => ({ [x.id_quickblox]: x }))
            // );
          }
          this.retreiveDialogs();

          // this.citas = response.data;
        });
    },
    cita_next(cita) {
      return new Date(cita) - new Date() > 0;
    },
    color_citas_status(dialog) {
      let color = "red";
      if (dialog) {
        for (let cita of dialog.citas) {
          let minTo = (new Date(cita.cita) - new Date()) / 1000 / 60;
          if (minTo < 0 && minTo > -15) {
            color = "green";
            break;
          } else if (minTo < 10 && minTo > -25) color = "yellow";
        }
      }
      return color;
    },
    timeValue(dialog) {
      let value = 0;
      if (dialog.citas) {
        for (let cita of dialog.citas) {
          let minTo = (new Date(cita.cita) - new Date()) / 1000 / 60;
          if (minTo < 0 && minTo > -15) {
            value = -(minTo / 15) * 100;
            console.log(value);
            break;
          }
        }
      }
      return value;
    },

    canCall(dialog) {
      let canCall = false;
      if (dialog.citas) {
        for (let cita of dialog.citas) {
          let minTo = (new Date(cita.cita) - new Date()) / 1000 / 60;
          if (minTo < 0 && minTo > -15) {
            canCall = true;
            break;
          }
        }
      }
      return canCall;
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    updateTime() {
      let cd = new Date();
      this.clock =
        this.zeroPadding(cd.getHours(), 2) +
        ":" +
        this.zeroPadding(cd.getMinutes(), 2) +
        ":" +
        this.zeroPadding(cd.getSeconds(), 2);
    },
    startRinging() {
      this.audio.loop = true;
      this.audio.play();
    },
    stopRinging() {
      this.audio.loop = false;
      this.audio.pause();
    },
    muteAudio() {
      if (this.audioMuted) {
        this.session.unmute("audio");
        this.audioMuted = false;
      } else {
        this.session.mute("audio");
        this.audioMuted = true;
      }
    },
    muteVideo() {
      if (this.videoMuted) {
        this.session.unmute("video");
        this.videoMuted = false;
      } else {
        this.session.mute("video");
        this.videoMuted = true;
      }
    },
    showChat() {
      if (this.chatShowed) {
        this.chatShowed = false;
      } else {
        this.chatShowed = true;
      }
    },
    loadMoreChats() {
      let limit = 50;
      var params = {
        chat_dialog_id: this.selectedDialog._id,
        sort_desc: "date_sent",
        limit: limit,
        skip: this.skipChats,
      };
      this.$QB.chat.message.list(params, (err, messages) => {
        if (messages) {
          console.log(messages);

          this.messages = this.messages.concat(messages.items);
          console.log(this.messages);
        } else {
          console.log(err);
        }
        if (messages.items) {
          this.skipChats = this.skipChats + limit;
        }
      });
    },
    selectDialog(dialog) {
      let limit = 50;

      this.selectedDialog = dialog;
      this.participants = dialog.occupants_ids;
      this.opponentId =
        dialog.user_id == this.userId
          ? dialog.occupants_ids.filter((id) => id != this.userId)[0]
          : dialog.user_id;
      this.skipChats = 0;
      var params = {
        chat_dialog_id: dialog._id,
        sort_desc: "date_sent",
        limit: limit,
        skip: this.skipChats,
      };
      this.$QB.chat.onMessageListener = this.onMessage;

      this.$QB.chat.message.list(params, (err, messages) => {
        if (messages) {
          this.messages = messages.items;
          console.log(messages);
        } else {
          console.log(err);
        }
        if (messages.items) {
          this.skipChats = this.skipChats + limit;
        }
      });
    },
    stopCall() {
      this.stopRinging();
      var extension = {};
      this.session.stop(extension);
      this.videocall = false;
      this.calling = false;
      this.showLocalVideo = false;
    },
    createCall() {
      this.videocall = true;
      this.calling = true;
      this.showLocalVideo = false;
      var sessionType = this.$QB.webrtc.CallType.VIDEO; // AUDIO is also possible
      var additionalOptions = {};

      this.session = this.$QB.webrtc.createNewSession(
        [this.opponentId],
        sessionType,
        null,
        additionalOptions
      );

      var mediaParams = {
        audio: true,
        video: true,
        options: {
          muted: false,
          mirror: false,
        },
        elemId: "remoteVideo",
      };

      this.session.getUserMedia(mediaParams, (err, stream) => {
        if (err) {
          console.log(err);
        } else {
          var extension = {};
          this.session.call(extension, function(error) {
            console.log(error);
          });
          this.localStream = stream;
          this.session.attachMediaStream("remoteVideo", stream);
          this.session.attachMediaStream("remoteVideoBlurred", stream);

          this.startRinging();
        }
      });
    },
    sendMessage(msg) {
      if (this.text.length > 0) {
        this.newMessagesCount = this.isChatOpen
          ? this.newMessagesCount
          : this.newMessagesCount + 1;
        this.messageList.unshift(msg);
      }
      this.text = "";
    },
    onMessageWasSent() {
      this.sending = true;

      if (this.file) {
        var inputFile = this.$refs.file.files[0];

        var fileParams = {
          name: inputFile.name,
          file: inputFile,
          type: inputFile.type,
          size: inputFile.size,
          public: false,
        };

        this.$QB.content.createAndUpload(fileParams, (error, result) => {
          if (!error) {
            // prepare a message
            var message = {
              type: this.selectedDialog.type === 3 ? "chat" : "groupchat",
              body: this.text || "[attachment]",
              extension: {
                save_to_history: 1,
                dialog_id: this.selectedDialog._id,
                attachments: [{ id: result.uid, type: "image" }],
              },
            };
            this.selectDialog(this.selectedDialog);

            this.file = null;

            message.id = this.$QB.chat.send(this.opponentId, message);
            this.onMessage(this.userId, message);
            this.sending = false;
          }
        });
      }
      if (this.text != "") {
        var message = {
          sender_id: this.userId,
          type: "chat",
          body: this.text,
          extension: {
            save_to_history: 1,
            date_sent: Math.round(new Date().getTime() / 1000),
            dialog_id: this.selectedDialog._id,
          },
          markable: 1,
        };
        this.selectedDialog.last_message = this.text;
        this.selectedDialog.last_message_date_sent = Math.round(
          new Date().getTime() / 1000
        );
        this.text = "";

        message.id = this.$QB.chat.send(this.opponentId, message);
        this.onMessage(this.userId, message);
        this.sending = false;
      }
    },
    openChat() {
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat() {
      this.isChatOpen = false;
    },
    // createUser(another) {
    //   var params = {
    //     login: this.login,
    //     password: this.password,
    //     full_name: this.full_name
    //   };
    //   if (another) {
    //     params = {
    //       login: this.login + "1",
    //       password: this.password + "1",
    //       full_name: this.full_name + "1"
    //     };
    //   }

    //   this.$QB.users.create(params, function(err, res) {
    //     if (err) {
    //       console.error("Create user error: " + JSON.stringify(err));
    //     } else {
    //       console.log(res);
    //     }
    //   });
    // },
    createSession() {
      var params = { login: this.currentUser.email, password: this.password };
      console.log("sesion");
      this.$QB.createSession(params, (err, res) => {
        // callback function
        if (err) {
          console.log(err, res);
        }
        this.$store.commit("setToken", res.token);
        this.token = res.token;
        params["token"] = res.token;
        this.$QB.login(params, (err, res) => {
          this.userId = res.id;
          this.name = res.full_name;
          this.connect();
        });

        //this.logIn();
      });
    },
    // logIn() {
    //   var params = {
    //     login: this.login,
    //     password: this.password,
    //     token: this.$store.state.token
    //   };
    //   this.$QB.login(params, (err, res) => {
    //     this.userId = res.id;

    //     this.retreiveDialogs();
    //     this.connect();
    //   });
    // },
    retreiveDialogs() {
      var filters = {};
      this.proximascitas = [];
      this.$QB.chat.dialog.list(filters, (error, dialogs) => {
        // this.dialogs = dialogs.items;
        dialogs.items.forEach((dialog) => {
          let user_id =
            dialog.user_id == this.userId
              ? dialog.occupants_ids.filter((id) => id != this.userId)[0]
              : dialog.user_id;
          if (this.citas[user_id]) {
            dialog["citas"] = this.citas[user_id];

            this.proximascitas.push(dialog);
          }
        });
        this.proximascitas.sort((a, b) =>
          new Date(a.citas[0].cita) < new Date(b.citas[0].cita) ? 1 : -1
        );
        console.log(dialogs, error);
      });
    },
    connect() {
      let params = {
        userId: this.userId,
        password: this.password, //password,
        token: this.token,
      };
      this.$QB.chat.connect(params, (error, contactList) => {
        if (error) {
          console.log(error, contactList);
          // this.$store.commit("setToken", null);
          // window.localStorage.setItem("token", null);
        }
        this.contactList = contactList;
      });
    },
    createDialog() {
      var params = {
        type: 3,
        occupants_ids: [117057566],
      };

      this.$QB.chat.dialog.create(params, function(error, conversation) {
        console.log(error, conversation);
      });
      this.$QB.chat.onMessageListener = this.onMessage;
    },
    onMessage(userId, message) {
      console.log(">>>>>>>>>>>>>>>>>>>>>");
      console.log("onMessage" + userId);
      console.log(message);
      if (
        (message.recipient_id == this.userId || !message.recipient_id) &&
        (this.selectedDialog._id == message.dialog_id ||
          this.selectedDialog._id == message.extension.dialog_id)
      ) {
        this.selectedDialog.last_message = message.message || message.body;
        this.messages.unshift(message);
      }
      console.log(">>>>>>>>>>>>>>>>>>>>>");
    },
    stopCalling() {
      this.videocall = false;
      this.calling = false;
      this.stopRinging();
    },
    videoCallEvents() {
      this.$QB.webrtc.onCallListener = (session, extension) => {
        console.log("CALLING ME!", session, extension);
      };
      // this.$QB.webrtc.onAcceptCallListener = function(
      //   session,
      //   userId,
      //   extension
      // ) {};
      this.$QB.webrtc.onRejectCallListener = (session, userId, extension) => {
        this.stopCalling();
        console.log("REJECTED CALL", session, userId, extension);
      };
      this.$QB.webrtc.onStopCallListener = (session, userId, extension) => {
        this.stopCalling();
        console.log("CALL ENDED", session, userId, extension);
      };
      // this.$QB.webrtc.onUpdateCallListener = function(
      //   session,
      //   userId,
      //   extension
      // ) {};
      // this.$QB.webrtc.onInvalidEventsListener = function(
      //   eventName,
      //   session,
      //   userId,
      //   userInfo
      // ) {};
      this.$QB.webrtc.onUserNotAnswerListener = (session, userId) => {
        this.stopCalling();
        console.log("NOT ANSWER", session, userId);
      };
      this.$QB.webrtc.onAcceptCallListener = () => {
        this.stopRinging();
      };
      this.$QB.webrtc.onRemoteStreamListener = (
        session,
        userId,
        remoteStream
      ) => {
        this.stopRinging();

        console.log(userId);
        this.showLocalVideo = true;
        this.videocall = true;

        this.session.attachMediaStream("localVideo", this.localStream);
        this.session.attachMediaStream("remoteVideo", remoteStream);
        this.session.attachMediaStream("remoteVideoBlurred", remoteStream);
      };
      // this.$QB.webrtc.onSessionConnectionStateChangedListener = function(
      //   session,
      //   userId,
      //   connectionState
      // ) {};
      // this.$QB.webrtc.onSessionCloseListener = function(session) {};
      // this.$QB.webrtc.onCallStatsReport = function(
      //   session,
      //   userId,
      //   stats,
      //   error
      // ) {};
    },
    // sendMessage(opponentId, message) {
    //   // var dialog = "...";

    //   // var message = {
    //   //   type: "chat",
    //   //   body: "How are you today?",
    //   //   extension: {
    //   //     save_to_history: 1,
    //   //     dialog_id: dialog._id
    //   //   },
    //   //   markable: 1
    //   // };

    //   message.id = this.$QB.chat.send(opponentId, message);
    // },

    initQB() {
      this.$QB.init(
        CREDENTIALS.appId,
        CREDENTIALS.authKey,
        CREDENTIALS.authSecret
      );

      this.createSession();
      this.videoCallEvents();

      // this.$QB.webrtc.onRemoteStreamListener = function(
      //   session,
      //   userID,
      //   remoteStream
      // ) {
      //   // attach the remote stream to DOM element
      //   console.log(userID);
      //   session.attachMediaStream("remoteVideo", remoteStream);
      // };
    },
    signOut() {
      AuthService.logOut();
    },
  },
};
</script>

<style lang="scss">
html {
  overflow-y: hidden;
  overflow: none;
}
body {
  overflow-y: hidden;
  overflow: none;
}
.background {
  position: fixed;
  bottom: 10px;
  z-index: 0;
  height: 100%;
  width: 100%;
  padding: 10px;
}
#remoteVideoBlurred {
  object-fit: fill;
  filter: blur(40px);
  -webkit-filter: blur(40px);
}
.videoremote {
  position: absolute;

  width: 100vw;
  height: 100vh;
}
.videorotated {
  position: absolute;
  transform: rotate(90deg);
  transform-origin: bottom left;
  width: 100vh;
  height: 100vw;
  margin-top: -100vw;

  z-index: 4;
  visibility: visible;
}
.v-application--wrap {
  max-height: 100vh;
}
#app {
  max-height: 100vh;
}
.v-application--is-ltr
  .v-list--dense.v-list--nav
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 5px !important;
}
// above the following import you can override default values of variables like $primary
</style>
